// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3cpPO","location":"Header_location__3zjr1"};